import React, { useState, useCallback, useEffect } from "react";
import { ToastMessage } from "../../../global/ToastMessage";
import { FPagoStyleStyle } from "./FPagoStyles";
import { useFormik } from "formik";
import TextField from "@material-ui/core/TextField";
import { Button, Grid } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { newPagoUnicoAction } from "./../../../ducks/pagoUnicoDuck";
import HeaderModal from "../../../global/headerModal";
import BackDrop from "./../../../global/BackDrop";
import ModalBase from "./../../../global/ModalBase";
import * as yup from "yup";
import ButtonBaseIcon from "./../../../global/BotonIcon";
import CreditCardIcon from "@material-ui/icons/CreditCard";
import PickerMod from "../../../global/PickersMod";
import CPago from "./CPago";
import { FormatoFecha } from "../../../utils/FormatFecha"
import { catTipoCambio } from "../../../constant/catTipoCambios"
import useCatalogos from "../../../hooks/useCatalogos";
const validationSchema = yup.object({
  monto: yup.number("Ingresa monto valido").required("Monto es requerido"),
  claveRastreo: yup
    .string("Ingresa numero valido")
    .required("Clave de rastreo es requerido"),
  tipoCambio: yup.number("Ingresa monto valido").optional(),
})

const InitalValues = {
  monto: "",
  claveRastreo: "",
  tipoCambio: 1,
}

const useToggle = (initialState = false) => {
  const [state, setState] = useState(initialState);
  const toggle = useCallback(() => setState((state) => !state), []);
  return [state, toggle];
};

const BotonPago = (props) => {
  const { row } = props;
  const [isOpen, setIsOpen] = useToggle();
  return (
    <div>
      <ButtonBaseIcon title="Cargar pago" onClick={setIsOpen}>
        <CreditCardIcon />
      </ButtonBaseIcon>
      <FPago open={isOpen} setOpen={setIsOpen} rowData={row} />
    </div>
  );
};

const FPago = (props) => {
  const { open = true, setOpen = () => { }, rowData = {} } = props
  const cambio = useCatalogos(`TipoCambio/${catTipoCambio.DOLARES}`)
  const dispatch = useDispatch()
  const classes = FPagoStyleStyle()
  const [isLoad, setIsLoad] = useState(false)
  const [selectDay, setSelectedDate] = useState(new Date())

  const formik = useFormik({
    initialValues: InitalValues,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      onSave(values)
    },
  })

  useEffect(() => {
    if (rowData.Moneda.id_moneda === catTipoCambio.DOLARES)
      formik.setFieldValue("tipoCambio", cambio.TipoCambio)
    else
      formik.setFieldValue("tipoCambio", InitalValues.tipoCambio)
  },[rowData.Moneda.id_moneda, cambio.TipoCambio]) // eslint-disable-line react-hooks/exhaustive-deps

  const onSave = (values) => {
    setIsLoad(true)
    let payload = {
      Id_cuenta: rowData.Movimiento?.Cuenta?.Id_Cuenta,
      Monto: values.monto,
      TipoCambio: values.tipoCambio,
      ClaveRastreo: `M_${values.claveRastreo}`,
      Referencia: rowData.Movimiento?.Referencia,
      fecha: FormatoFecha({ date: selectDay, formato: "yyyy-MM-dd" }),
    }
    dispatch(newPagoUnicoAction(payload)).then((Response) => {
      switch (Response.status) {
        case 500:
          ToastMessage.fire({
            icon: "error",
            title: "Ha habido un problema de conexión con el servidor",
          });
          break
        case 400:
          ToastMessage.fire({
            icon: "warning",
            title: "<strong>Atención</strong>",
            text: "Al menos un dato no se ha enviado, favor de llenar el registro.",
          });
          break
        default:
          handleClose();
          ToastMessage.fire({
            icon: "success",
            title: "Ingreso Correcto",
          });
          break
      }
      setIsLoad(false)
    })
  }

  const LimpiarForm = () => {
    formik.resetForm(InitalValues)
  }

  const handleClose = () => {
    setOpen()
    LimpiarForm()
  }

  return (
    <ModalBase classes={classes} open={open} onClose={handleClose}>
      <HeaderModal handleClose={handleClose} titulo={`Nuevo pago`} />
      <form onSubmit={formik.handleSubmit}>
        <Grid container className={classes.containerSpacing}>
          <Grid item xs={6}>
            <CPago
              Nombre={`${rowData.Movimiento?.Cuenta?.Nombre} ${rowData.Movimiento?.Cuenta?.Apellido_Paterno} ${rowData.Movimiento?.Cuenta?.Apellido_Materno}`}
              Referencia={rowData.Movimiento?.Referencia}
              tipoCambio={cambio.TipoCambio}
              moneda={rowData.Moneda}
              montoMensual={rowData.paquete?.Monto_Mensual}
            />
          </Grid>
          <Grid item xs={6}>
            <Grid container className={classes.containerSpacing}>
              <Grid item xs={12}>
                <TextField
                  required
                  id="input-monto"
                  label="Monto"
                  type="text"
                  variant="outlined"
                  name="monto"
                  value={formik.values.monto}
                  onChange={formik.handleChange}
                  error={formik.touched.monto && Boolean(formik.errors.monto)}
                  helperText={formik.touched.monto && formik.errors.monto}
                  className={classes.textField}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  id="input-claveRastreo"
                  label="Clave de rastreo"
                  type="text"
                  variant="outlined"
                  name="claveRastreo"
                  value={formik.values.claveRastreo}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.claveRastreo &&
                    Boolean(formik.errors.claveRastreo)
                  }
                  helperText={
                    formik.touched.claveRastreo && formik.errors.claveRastreo
                  }
                  className={classes.textField}
                />
              </Grid>
              {
                (rowData.Moneda?.id_moneda === catTipoCambio.DOLARES) &&
                <Grid item xs={12}>
                  <TextField
                    required
                    id="input-tipoCambio"
                    label="Tipo de cambio"
                    type="text"
                    variant="outlined"
                    name="tipoCambio"
                    value={formik.values.tipoCambio}
                    onChange={formik.handleChange}
                    error={formik.touched.tipoCambio && Boolean(formik.errors.tipoCambio)}
                    helperText={formik.touched.tipoCambio && formik.errors.tipoCambio}
                    className={classes.textField}
                  />
                </Grid>
              }
              <Grid item xs={11}>
                <PickerMod
                  id="FechaDePago"
                  label="Fecha pago"
                  selectedDate={selectDay}
                  setSelectedDate={setSelectedDate}
                  disablePast={false}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container className={classes.containerSpacing}>
          <Grid item xs={12} className={classes.modalBotonesCenter}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              className={classes.modalBoton}
            >
              {"Aplicar"}
            </Button>
          </Grid>
        </Grid>
        <BackDrop open={isLoad} />
      </form>
    </ModalBase>
  );
};
export default BotonPago;
